import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Edit = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11.8901 5.05005C12.3201 7.81005 14.5601 9.92005 17.3401 10.2M3 22.0001H21M13.2594 3.60009L5.04936 12.2901C4.73936 12.6201 4.43936 13.2701 4.37936 13.7201L4.00936 16.9601C3.87936 18.1301 4.71936 18.9301 5.87936 18.7301L9.09936 18.1801C9.54936 18.1001 10.1794 17.7701 10.4894 17.4301L18.6994 8.74009C20.1194 7.24009 20.7594 5.53009 18.5494 3.44009C16.3494 1.37009 14.6794 2.10009 13.2594 3.60009Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
